import { render } from "./FormPieChart.vue?vue&type=template&id=4064066c&scoped=true"
import script from "./FormPieChart.vue?vue&type=script&lang=js"
export * from "./FormPieChart.vue?vue&type=script&lang=js"

import "./FormPieChart.vue?vue&type=style&index=0&id=4064066c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4064066c"]])

export default __exports__